import { Box, ClickAwayListener, Fade, Stack } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FettiCheckbox from "../FettiCheckbox";
import {
  Color,
  EducationCategories,
  EducationTagToName,
  FontStyle,
  JobDisplays,
} from "../../constants";
import { JobFloatScreen } from "../../utils/jobUtils";

const CategoryRow = ({ selected, toggleFilter, name, handleClose }) => {
  const [bgColor, setBgColor] = useState("transparent");
  const flash = (color) => {
    let ts = 0;
    const interval = setInterval(() => {
      ts += 1;
      if (ts === 1 || ts === 9) {
        // if (ts === 1) {
        setBgColor(color);
      } else if (ts === 7 || ts === 16) {
        // } else if (ts === 7 || ts === 16) {
        setBgColor("transparent");
      } else if (ts > 20) {
        clearInterval(interval);
      }
    }, 1000 / 60);
  };
  useEffect(() => {}, [selected]);
  return (
    <Stack
      sx={{
        ...FontStyle.body,
        fontSize: "14px",
        color: "#000",
        py: "5px",
        paddingLeft: "20px",
        backgroundColor: bgColor,
        "&:hover": {
          backgroundColor: bgColor === "transparent" ? "#eef" : bgColor,
        },
      }}
      direction="row"
      alignItems="center"
      spacing={1}
      onClick={(e) => {
        e.stopPropagation();
        if (selected) {
          // flash("#eee");
        } else {
          flash(Color.primaryLight);
          setTimeout(() => {
            toggleFilter();
          }, 200);
          setTimeout(() => {
            handleClose();
          }, 300);
        }
      }}>
      <FettiCheckbox selected={selected} width={14} />
      <Box>{name}</Box>
    </Stack>
  );
};
const menuPadding = 16;
const underlinePadding = 0;
// this is a dropdown in mobile
const EducationCategorySelectorMobile = ({ categoryIdx, setCategoryIdx }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <Box
      sx={{
        width: "100%",
        zIndex: 1,
      }}>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Stack
          direction="row"
          alignItems="center"
          onClick={() => setOpen(!open)}
          sx={{
            width: "100%",
            borderRadius: JobDisplays.borderRadius,
            backgroundColor: JobDisplays.backgroundColor,
            boxShadow: JobDisplays.boxShadow,
            ...FontStyle.body,
            height: "40px",
            position: "relative",
            cursor: "pointer",
            transition:
              "box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out",
            zIndex: 1,
            "&:hover": {
              transform: "scale(1.01)",
            },
            ...(open && {
              zIndex: 2002,
              boxShadow:
                "0px 0px 10px #0AE9F080, 0px 0px 10px #0110FA80, 0px 0px 5px #0110FA80",
              transform: "scale(1.01)",
            }),
          }}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              borderRadius: JobDisplays.borderRadius,
              // background:
              //   "linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(205,205,210,0.15) 100%)",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.2) 0%, #A6EFF580 100%)",
              opacity: 0.2,
              transition: "opacity 0.3s ease-in-out",
              ...(!open && {
                "&:hover": {
                  opacity: 0.4,
                },
              }),
              // "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            }}
          />
          <Box
            sx={{
              width: "100%",
              paddingLeft: "16px",
            }}>
            {EducationTagToName[EducationCategories[categoryIdx]]}
          </Box>
          <Stack
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{
              width: "80px",
              backgroundColor: Color.deepPurple,
              height: "100%",
              borderRadius: `0px ${JobDisplays.borderRadius} ${JobDisplays.borderRadius} 0px`,
            }}>
            <ArrowDropDownIcon
              sx={{
                color: "#fff",
                width: "32px",
                height: "32px",
              }}
            />
          </Stack>
          <Fade in={open}>
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{
                position: "absolute",
                // top: barHeight + 12,
                bottom: "-12px",
                transform: "translateY(100%)",
                left: "0",
                width: "100%",
                ...FontStyle.body,
                borderRadius: JobDisplays.borderRadius,
                border: "1px solid #0004",
                backgroundColor: JobDisplays.backgroundColor,
                boxShadow: "2px 2px 8px rgb(0 0 0 / 10%)",
                overflow: "hidden",
                paddingTop: "12px",
                paddingBottom: "12px",
                userSelect: "none",
              }}>
              <Stack
                sx={{
                  overflow: "scroll",
                }}
                direction="column">
                {EducationCategories.map((category, idx) => (
                  <CategoryRow
                    key={idx}
                    name={EducationTagToName[category]}
                    selected={categoryIdx === idx}
                    toggleFilter={() => setCategoryIdx(idx)}
                    handleClose={() => setOpen(false)}
                  />
                ))}
              </Stack>
            </Box>
          </Fade>
        </Stack>
      </ClickAwayListener>
      {open && <JobFloatScreen zIndex={-1} />}
    </Box>
  );
};

export default EducationCategorySelectorMobile;
